/* eslint-disable max-len */
import types from '../types'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import {getAuthKey} from './getAuthKey'
import {getCustomDomain} from './getCustomDomain'
import {getUserData} from './getUserData'
import {signOut} from './signOut'
// import {getSearchSize} from './getSearchSize'

export const onSignInSuccess = (user, database) => async (dispatch, getState) => {
  const authForm = getState().userReducer.authForm
  if (user && user.uid) {
    let orgId
    const orgIdRef = database.ref(`users/${user.uid}/organization/orgId`)
    orgIdRef.get()
        .then(async (snapshot) => {
          orgId = snapshot.val()
          const vkgDomain = await dispatch(getCustomDomain(database, orgId))
          const userData = await getUserData(database, orgId, user.uid)
          if (!orgId || !vkgDomain) {
            dispatch(signOut(false))
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                isLoading: false,
                userMessage: 'You do not appear to have a Lazarus Account. Reach out to your Lazarus Representative or reach out to us through lazarusai.com.',
                notificationType: 3,
                notificationIcon: 'warning',
                isNotificationVisible: true,
              },
            })
            throw Error('Not a valid user - signing out')
          }
          dispatch(getAuthKey(database, orgId))
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              authForm: {
                ...authForm,
                orgId: orgId,
              },
              userData: userData,
              isLoading: false,
              isSignedIn: true,
            },
          })
        })
        .catch((err) => {
          console.log('error', err)
          if (orgId) {
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                isLoading: false,
                isSignedIn: false,
                userMessage: 'Sign in failure.',
                notificationType: 2,
                notificationIcon: 'warning',
                isNotificationVisible: true,
              },
            })
          }
        })
  }
}
